export default __webpack_public_path__ + "static/media/gamesglobal.8a174195.jpg";